import { useEffect } from "react";

const DEFAULT_DESCRIPTION = "Compare caravan holiday prices across every major UK operator in one place. Real prices, real parks, real deals — Haven, Parkdean, Butlins and more.";

/**
 * Minimal client-side SEO: sets <title> and meta description.
 * For full SSR/SEO we'd use Next.js or react-helmet; for an MVP this is the right tradeoff.
 */
export default function useSeo({ title, description, canonical, keywords }) {
  useEffect(() => {
    if (title) document.title = `${title} | ParkScanner`;
    setMeta("description", description || DEFAULT_DESCRIPTION);
    if (keywords) setMeta("keywords", keywords);
    if (canonical) setLinkRel("canonical", canonical);
    // Open Graph for social shares
    setMetaProperty("og:title", title || "ParkScanner");
    setMetaProperty("og:description", description || DEFAULT_DESCRIPTION);
    setMetaProperty("og:type", "website");
    if (canonical) setMetaProperty("og:url", canonical);
  }, [title, description, canonical, keywords]);
}

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
  el.setAttribute("content", content);
}
function setMetaProperty(prop, content) {
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("property", prop); document.head.appendChild(el); }
  el.setAttribute("content", content);
}
function setLinkRel(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
}
